import { environmentMain } from "./Routes/serverRoutes";
export const environment = {
  production: false,
  network: environmentMain,
  etherscanKey: "EH7DJ1HAGTNI8Q36KQT6E77CDYX36KG27P",
  infuraProjectId: "ece2a3079cb54d0883716a41e515eb44",
  appLocked: false,
};
 
 